// branches.js - Branch service for managing branch data
// This will be replaced with API calls later

class BranchService {
    constructor() {
      // Static branch data - will be replaced with API calls later
      this.branches = [
        { id: null, name: 'All Branches' }, // null id for all branches
        { id: 1, name: 'Thika Branch' },
        { id: 2, name: 'Narok Branch' },
        { id: 3, name: 'Meru Branch' }
      ];
    }
  
    // Get all branches
    getBranches() {
      return Promise.resolve(this.branches);
    }
  
    // Get branch by ID
    getBranchById(id) {
      const branch = this.branches.find(b => b.id === id);
      return Promise.resolve(branch || null);
    }
  
    // Get branch name by ID
    getBranchName(id) {
      const branch = this.branches.find(b => b.id === id);
      return branch ? branch.name : 'Unknown Branch';
    }
  
    // Future method for API integration
    async fetchBranchesFromAPI() {
      // This will be implemented later to fetch from the backend
      // return apiService.fetchBranches();
      throw new Error('API integration not implemented yet');
    }
  }
  
  // Create and export singleton instance
  const branchService = new BranchService();
  export default branchService;
  
  // Also export the class
  export { BranchService };